import React, { useState } from 'react'
import classNames from 'classnames'

import Icon from '../Icon'
import './styles.scss'

const TabInfo = ({ tab, product }) => {
  const [status, setStatus] = useState(false)

  return (
    <div className='modal_product_tabs-wrapper'>
      <div
        className='modal_product_title'
        onClick={() => setStatus(!status)}
      >
        {tab}
        <span className={classNames({ down: !status, up: status })}>
          <Icon iconName='chevron-down' />
        </span>
      </div>
      <div
        className={classNames('modal_product_drop-down', { opened: status, closed: !status })}
        dangerouslySetInnerHTML={{ __html: product }}
      />
    </div>
  )
}

export default TabInfo
